import { Button, TrashIcon } from "@coolset/cs-ui";
import { Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import { LayoutContext } from "contexts/LayoutContext/LayoutContext";
import { MainSurveyStore } from "../../hooks/useMainSurvey";
import { SurveyBlocks } from "../../surveyBlocks";
import { mainSurveyClient } from "../../client/mainSurveyClient";
import { BulkConditions } from "modules/Conditions/components/BulkConditions";
import { BulkRelatedSupportingInfos } from "modules/SupportingInfo/components/BlockFormSupportingInfo/BulkRelatedSupportingInfos";
import { BulkDeleteDialog } from "../SubSections/BulkDeleteDialog";

interface BulkBlockFormProps {
  mainSurveyStore: MainSurveyStore;
  selectedBlocks: SurveyBlocks.Block[];
  onDeleted: (deletedIds: string[]) => void;
  onBulkSaved: () => void;
}

export const BulkBlockForm = (props: BulkBlockFormProps) => {
  const { mainSurveyStore, selectedBlocks, onDeleted, onBulkSaved } = props;
  const { genericError, genericSuccess } = useContext(LayoutContext);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleDelete = async () => {
    const results = await Promise.allSettled(
      selectedBlocks.map((b) => mainSurveyClient.deleteSurveyBlock(b.surveyId, b.id)),
    );
    const deletedIds: string[] = [];
    let failed = 0;
    results.forEach((r, i) => {
      if (r.status === "fulfilled") deletedIds.push(String(selectedBlocks[i].id));
      else failed += 1;
    });

    if (failed) genericError(`Failed to delete ${failed} of ${selectedBlocks.length} cells.`);
    else genericSuccess(`Deleted ${deletedIds.length} cells.`);

    onDeleted(deletedIds);
    setConfirmOpen(false);
  };

  return (
    <div className="layout-block-form">
      <header className="_d-flex-ali-center-jc-sb-sm-gap">
        <Typography variant="h4">{selectedBlocks.length} cells selected</Typography>
        <Button variant="text" color="secondary" onClick={() => setConfirmOpen(true)}>
          <TrashIcon /> Delete {selectedBlocks.length} cells
        </Button>
      </header>

      <BulkConditions mainSurveyStore={mainSurveyStore} selectedBlocks={selectedBlocks} onSaved={onBulkSaved} />
      <BulkRelatedSupportingInfos
        mainSurveyStore={mainSurveyStore}
        selectedBlocks={selectedBlocks}
        onSaved={onBulkSaved}
      />

      {confirmOpen && (
        <BulkDeleteDialog
          count={selectedBlocks.length}
          onConfirm={handleDelete}
          onCancel={() => setConfirmOpen(false)}
        />
      )}
    </div>
  );
};
